module.exports = __webpack_public_path__ + "img/mundo-mama-title.e6036303.png";